<script>
  export let label = "";
  export let helpText = "";
  export let errorText = "";
  export let width = 200;
  export let height = "auto";
	export let inputId;

  let focused = false;

	$: inputId = label + makeId(10);
	$: error = errorText.length > 0;

	function makeId(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
	}
</script>

<div class="container" style="width: {width}; height: {height};">
  <label for={inputId} class:focused={focused && !error} class:error>{label}</label>
  <div class="content" class:error>
    <slot></slot>
  </div>
  <span class="helpText" class:error>{errorText ? errorText : helpText}</span>
</div>

<style>
  .container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    pointer-events: auto;
  }
  
  .content {
    display: grid;
	}

	.content.error :global(input) {
    border-color: var(--error-color);
    animation: shake 0.1s;
    animation-iteration-count: 3;
  }
	
  label {
    text-align: left;
    padding: 0px 4px;
    color: #333;
    font-size: var(--label-font-size)px;
  }

  label.error, span.error {
    color: var(--error-color);
  }

  .helpText {
    display: block;
    position: relative;
    text-align: left;
    top: -2px;
    left: 4px;
    font-size: 13px;
    font-style: italic;
    color: #777;
  }
	
	@keyframes shake {
    0% { transform: translate(1px, 0px); }
    33% { transform: translate(0px, 0px); }
    66% { transform: translate(-1px, 0px); }
    100% { transform: translate(0px, 0px); }
  }
</style>